export const getParameterByName = (name: string): string | null => {
  name = name.replace(/[\[\]]/g, '\\$&');

  const url = window.location.href;
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const parseParams: (arg0: string) => any = (paramsString: string): any => {
  paramsString = paramsString.slice(1, paramsString.length);

  const pieces = paramsString.split('&');
  const data: any = {};
  let parts;

  for (const element of pieces) {
    parts = element.split('=');
    if (parts.length < 2) {
      parts.push('');
    }
    data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
  }
  return data;
};
